module.exports = __webpack_public_path__ + "static/img/hr-downloads-is-built_2.25818d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/hr-downloads-is-built_2.png
// module id = jxRk
// module chunks = 0